<template>
  <ChapterBlockTemplate v-if="itemsCount" :opened="opened">
    <template #header>
      <ChapterBlockHeader
        :category="category"
        :has-link="!opened"
        :items-count="itemsCount"
      />
    </template>
    <template #items>
      <ChapterBlockExerciseItems :category="category" />
      <ChapterBlockPostItems :category="category" />
      <ChapterBlockCategoryItems :category="category" />
    </template>
  </ChapterBlockTemplate>
</template>

<script setup lang="ts">
interface Props {
  category: CategorySchema;
  opened?: boolean;
}

const props = defineProps({
  category: null,
  opened: { type: Boolean, default: true }
});

const itemsCount = computed(() => {
  switch (props.category.childrenType) {
    case 'annals':
      return props.category.children.length;
    case 'practice': {
      let itemsCount = props.category.children.reduce((acc, cat) => {
        if (cat.children.length) {
          acc += cat.children.length;
        } else {
          acc += cat.contentType !== ContentTypes.SubChapter ? 1 : 0;
        }
        return acc;
      }, 0);
      // Fix temp to show "explications lineaires"
      itemsCount += props.category?.posts?.length ?? 0;
      return itemsCount;
    }
    case 'quiz':
    case 'pairing':
    case 'fillblank':
    case 'flashcard': {
      return props.category.exercises.length;
    }
    case 'course':
    case 'course_video':
      return props.category.posts.length;
    default:
      return (
        props.category.children.length +
        props.category.exercises.length +
        props.category.posts.length
      );
  }
});

const { progressions: allProgressions } = inject(INJECT_PROGRESSION_EXERCISES);

const exerciseIds = computed(() => {
  if (!props.category.exercises) return [];
  return props.category.exercises.map((exercise) => exercise.id);
});

const { exercisesDoneCount, exercisesCount } = useExercisesChapterProgressions(
  allProgressions,
  exerciseIds
);
</script>
